import EkomiFlag from "../../../../../../packages/design-system/src/EkomiFlag";
import * as React from 'react';
export default {
  EkomiFlag,
  React
};